import React from 'react'
import { KINOTICKETS } from '../../constants/paymentProvider'
import getDayKey from '../../functions/getDayKey'
import getMomentDateObj from '../../functions/getMomentDateObj'
import getShowtimeKey from '../../functions/getShowtimeKey'
import Translation from '../../General/Translation'

const BuyTicketLink = ({state, movies, translation, openIframe, cinemas, clusterCinemaActive}) => {
    const {currentMovieID, currentMovieDate, currentMovieShowtime, currentCinema } = state
    let deeplinkURL = null
    let showId = null
    let cinemaDataProvider
    let cinemaPk
    let alternativeLink
    
    if(clusterCinemaActive) {
        if(currentCinema !== '') {
            const cinema = cinemas[currentCinema]
            cinemaPk = currentCinema
            cinemaDataProvider = cinema.scope.cinemaDataProvider
        }
    } else {
        const cinemas = pmkinoFrontVars.apiData.cinemas.items
        const currentCinemaId = pmkinoFrontVars.cliData.currentCinemaId
        const cinema = cinemas[currentCinemaId]
        
        if(!cinema) {
            return ''
        }

        cinemaPk = currentCinemaId
        cinemaDataProvider = cinema.scope.cinemaDataProvider
    }
    
    if(currentMovieID && currentMovieDate && currentMovieShowtime && (clusterCinemaActive && currentCinema || !clusterCinemaActive)) {
        const currentMovie = movies[currentMovieID] 
        const {alternativeLinks} = currentMovie
        alternativeLink = alternativeLinks && alternativeLinks[cinemaPk]
        
        currentMovie.performances.map(performance => {
            const performanceDate = getMomentDateObj(performance.timeUtc, translation.timezone)
            
            if(getDayKey(performanceDate) === currentMovieDate && getShowtimeKey(performanceDate) === currentMovieShowtime) {
                showId = performance.id
                deeplinkURL = performance.deeplinkURL
            }
        })
    }
    
    if(alternativeLink) {
        return (
            <div className={'button movie-buy-tickets-button-link-wrapper'}>
                <a className={'movie-buy-tickets-button-link-container cursor-pointer'} href={alternativeLink} rel="noreferrer" target="_blank">
                    <span className={'movie-buy-tickets-button-link'}><Translation id="tickets" trans={translation}>Tickets</Translation></span>
                </a>
            </div>
        )
    } else if((deeplinkURL || showId) && cinemaDataProvider && cinemaDataProvider.type !== KINOTICKETS) {
        return (
            <div className={'button movie-buy-tickets-button-link-wrapper'}>
                <a className={'movie-buy-tickets-button-link-container cursor-pointer'} onClick={() => {openIframe(true, deeplinkURL, showId, cinemaPk)}} rel="noreferrer" target="_blank">
                    <span className={'movie-buy-tickets-button-link'}><Translation id="tickets" trans={translation}>Tickets</Translation></span>
                </a>
            </div> 
        )
    } else if((deeplinkURL || showId) && cinemaDataProvider && cinemaDataProvider.type === KINOTICKETS) {
        return  (
            <div className={'button movie-buy-tickets-button-link-wrapper'}>
                <a className={'movie-buy-tickets-button-link-container cursor-pointer'} href={deeplinkURL} rel="noreferrer" target="_blank">
                    <span className={'movie-buy-tickets-button-link'}><Translation id="tickets" trans={translation}>Tickets</Translation></span>
                </a>
            </div>
        )
    } else {
        return  (
            <div className={'movie-buy-tickets-button-link-container disabled'}>
                <div className={'movie-buy-tickets-button-link text-medium-navigation'}>
                    <Translation id="selectDesiredMovie" trans={translation}>Wunschfilm auswählen</Translation>
                </div>
            </div>
        )
    }
}

export default BuyTicketLink